import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCirclePlaceholder = ({ color = 'var(--color-accent-1-50)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
            <rect width="16" height="16" x="0.773" y="0.717" fill={color} fillOpacity="0.1" rx="8"></rect>
        </svg>
    </div>
);

export default IconCirclePlaceholder;
